// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__38u_L","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__JriUW"};